import reduxStore from "../redux/store";


export default function isUserLogin() {
    const authUser = reduxStore.getState().authReducer;
    // console.log("reduxStore");
    // console.log(authUser);

    return Object.entries(authUser).length > 0 ? true : false;
}